<template>
  <div>
    <vue-good-table
      id="list-campaign-table"
      class="vgt-no-border table-campaign"
      mode="remote"
      :columns="columns"
      :rows="campaigns"
      :pagination-options="{
        enabled: totalCampaign > 0,
        perPage:pageLength,
      }"
      :sort-options="{
        enabled: false
      }"
      :is-loading="loading"
      @on-sort-change="onSortChange"
    >
      <template
        slot-scope="props"
        slot="table-column"
      >
        <span v-if="props.column.field === 'checkbox'">
          <input
            ref="headerCb"
            type="checkbox"
            :checked="isAllChecked"
            @change="onToggleAll($event.target.checked)"
          >
        </span>
        <span v-else>{{ props.column.label }}</span>
      </template>
      <template
        slot-scope="props"
        slot="table-row"
      >
        <span v-if="props.column.field === 'checkbox'">
          <input
            type="checkbox"
            :checked="isRowChecked(props.row)"
            @change="onToggleRow(props.row, $event.target.checked)"
          >
        </span>
        <span v-if="props.column.field === 'toggleStatus'">
          <b-form-checkbox
            :id="props.row.campaign_id"
            data-testid="toggle-campaign"
            class="custom-control-success"
            name="check-button"
            switch
            inline
            :checked="isCampaignActive(props.row)"
            @change="onChangeCampaignStatus(props.row, $event)"
          />
        </span>
        <span
          v-if="props.column.field === 'campaignName'"
        >
          <p class="mb-0 font-weight-600">
            <b-img
              v-if="getCampaignType(props.row) === 'S++'"
              fluid
              width="18px"
              height="18px"
              :src="require('@/assets/images/icons/ic-smart-plus-plus.svg')"
              alt="campaign smart+"
              style="margin-right: 2px;"
            />
            <b-img
              v-if="getCampaignType(props.row) === 'S+'"
              fluid
              width="19px"
              height="19px"
              :src="require('@/assets/images/icons/ic-smart-plus.svg')"
              alt="campaign smart+"
              style="margin-right: 2px;"
            />
            {{ props.row.campaign_name }}
          </p>
          <p class="mb-0 text-placeholder">ID: {{ props.row.campaign_id }}</p>
        </span>

        <div
          v-else-if="props.column.field === 'budget'"
          class="d-flex flex-column"
        >
          <span>{{ props.row.budget_mode === 'BUDGET_MODE_INFINITE' ? 'All' : `${props.row.budget} USD` }}</span>
          <span
            class="font-italic text-gray"
            style="font-size: 12px"
          >{{ getBudgetType(props.row.budget_mode) }}</span>
        </div>

        <div
          v-else-if="props.column.field === 'status'"
          class="d-flex flex-column"
        >
          <span
            v-if="statusCampaign(props.row)"
            class="campaign-status"
            :class="statusVariant(props.row)"
          >
            {{ statusCampaign(props.row) }}
          </span>
          <span v-else> N/A </span>
        </div>

        <div
          v-else-if="props.column.field === 'createdAt'"
          class="d-flex flex-column"
        >
          <span>{{ createdDate(props.row.create_time ) }}</span>
        </div>

        <!-- Column: Actions -->
        <div
          v-else-if="props.column.field === 'actions'"
          class="text-center"
        >
          <div
            v-b-tooltip.hover.top.v-light="props.row.objective_type !== 'APP_PROMOTION' && props.row.objective_type !== 'LEAD_GENERATION' && props.row.objective_type !== 'WEB_CONVERSIONS' ? 'This campaign cannot be duplicated. Only App Promotion, Lead Generation, or Web Conversion campaigns are supported.' : ''"
          >
            <btn-loading
              variant-convert="btn-submit-outline"
              pill
              class="d-flex align-items-center"
              :disabled="props.row.objective_type !== 'APP_PROMOTION' && props.row.objective_type !== 'LEAD_GENERATION' && props.row.objective_type !== 'WEB_CONVERSIONS'"
              @click="duplicateCampaign(props.row)"
            >
              <feather-icon
                class="button__icon mr-50 cursor-pointer"
                icon="CopyIcon"
              />
              <span>{{ getCampaignType(props.row) === 'S++' ? 'Duplicate' : 'Clone to S++' }}</span>
            </btn-loading>
          </div>
          <!--          <span>-->
          <!--            <b-dropdown-->
          <!--              variant="link"-->
          <!--              toggle-class="text-decoration-none"-->
          <!--              no-caret-->
          <!--            >-->
          <!--              <template v-slot:button-content>-->
          <!--                <feather-icon-->
          <!--                  icon="MoreVerticalIcon"-->
          <!--                  size="16"-->
          <!--                  class="text-body align-middle mr-25"-->
          <!--                />-->
          <!--              </template>-->
          <!--              <b-dropdown-item @click="duplicateCampaign(props.row)">-->
          <!--                <feather-icon-->
          <!--                  class="mr-50"-->
          <!--                  icon="CopyIcon"-->
          <!--                  @click="duplicateCampaign(props.row)"-->
          <!--                />-->
          <!--                <span>{{ $t('campaign.duplicate') }}</span>-->
          <!--              </b-dropdown-item>-->
          <!--              &lt;!&ndash;              <b-dropdown-item @click="editCampaign(props.row)">&ndash;&gt;-->
          <!--              &lt;!&ndash;                <feather-icon&ndash;&gt;-->
          <!--              &lt;!&ndash;                  class="mr-50"&ndash;&gt;-->
          <!--              &lt;!&ndash;                  icon="EditIcon"&ndash;&gt;-->
          <!--              &lt;!&ndash;                />&ndash;&gt;-->
          <!--              &lt;!&ndash;                <span>{{ $t('campaign.edit') }}</span>&ndash;&gt;-->
          <!--              &lt;!&ndash;              </b-dropdown-item>&ndash;&gt;-->
          <!--              &lt;!&ndash;              <b-dropdown-item @click="viewCampaign(props.row)">&ndash;&gt;-->
          <!--              &lt;!&ndash;                <feather-icon&ndash;&gt;-->
          <!--              &lt;!&ndash;                  class="mr-50"&ndash;&gt;-->
          <!--              &lt;!&ndash;                  icon="EyeIcon"&ndash;&gt;-->
          <!--              &lt;!&ndash;                />&ndash;&gt;-->
          <!--              &lt;!&ndash;                <span>{{ $t('campaign.view') }}</span>&ndash;&gt;-->
          <!--              &lt;!&ndash;              </b-dropdown-item>&ndash;&gt;-->
          <!--            </b-dropdown>-->
          <!--          </span>-->
        </div>

        <!-- Column: common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        v-if="totalCampaign > 0"
        slot="pagination-bottom"
      >
        <div
          class="d-flex flex-wrap mt-1 pl-2 pb-1 justify-content-between align-items-center"
        >
          <div class="d-flex align-items-center mb-0">
            <span class="text-nowrap">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="pages"
              class="mx-1"
              @input="handlePerPageChange"
            />
            <span class="text-nowrap"> of {{ totalCampaign }} campaigns </span>
          </div>
          <div v-if="totalCampaign > pageLength">
            <b-pagination
              :total-rows="totalCampaign"
              :value="currentPage"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mt-md-0 mb-0 pagination-table"
              @change="handleChangePage"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>

      <!-- custom loading  -->
      <template slot="loadingContent">
        <b-spinner
          variant="primary"
          type="grow"
          small
        />
      </template>

      <!-- no account image -->
      <div
        slot="emptystate"
        class="text-center my-1"
      >
        <b-img
          alt="No account"
          class="img"
          :src="require('@/assets/images/common/no-data-table.svg')"
        />
      </div>
      <!-- /no account image -->
    </vue-good-table>

    <duplicate-campaign-modal
      ref="open-duplicate-campaign-modal"
      :campaign-duplicate="campaignDuplicate"
      :advertiser-id="advertiserId"
    />
  </div>
</template>
<script>
import {
  BFormCheckbox,
  BFormSelect,
  BImg, BPagination, BSpinner, VBTooltip,
  // BDropdown, BDropdownItem,
} from 'bootstrap-vue'
import get from 'lodash/get'
import { createNamespacedHelpers } from 'vuex'
import { VueGoodTable } from 'vue-good-table'
import { CAMPAIGN_STATUS } from '@/constants'
import DuplicateCampaignModal from '@/views/campaign/components/duplicate/DuplicateCampaignModal.vue'
import campaignMixin from '@/mixins/campaignMixin'
import BtnLoading from '@/layouts/components/BtnLoading.vue'
import dayjs from 'dayjs'
import Ripple from 'vue-ripple-directive'
import { toastification } from '@core/mixins/toast'

const { mapActions, mapGetters } = createNamespacedHelpers('campaign')

export default {
  components: {
    BFormCheckbox,
    BFormSelect,
    BtnLoading,
    DuplicateCampaignModal,
    BImg,
    BPagination,
    BSpinner,
    // BDropdown,
    // BDropdownItem,
    VueGoodTable,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  mixins: [campaignMixin, toastification],
  props: {
    advertiserId: {
      type: Object,
      default: () => {
      },
    },
    campaignIds: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      campaigns: [],
      campaignDuplicate: {},
      campaignSelected: [],
      rangeDate: {
        startDate: null,
        endDate: null,
      },

      currentPage: 1,

      // sort
      sortTerm: {
        field: '',
        type: '',
      },

      // per page
      pageLength: 10,
      pages: [10, 20, 50],

      columns: [
        {
          label: '',
          field: 'checkbox',
          thClass: 'p-1 border-0 header-table-mf',
          tdClass: 'p-1 border-top-0 border-left-0 border-right-0 border-bottom-1 align-middle',
        },
        {
          label: 'On/off',
          field: 'toggleStatus',
          thClass: 'p-1 border-0 header-table-mf',
          tdClass: 'p-1 border-top-0 border-left-0 border-right-0 border-bottom-1 align-middle',
        },
        {
          label: this.$t('campaign.campaignName'),
          field: 'campaignName',
          thClass: 'p-1 border-0 header-table-mf',
          tdClass: 'p-1 border-top-0 border-left-0 border-right-0 border-bottom-1 align-middle',
        },
        // {
        //   label: this.$t('campaign.status'),
        //   field: 'status',
        //   thClass: 'p-1 border-0 header-table-mf',
        //   tdClass:
        //     'p-1 border-top-0 border-left-0 border-right-0 border-bottom-1 align-middle',
        // },
        {
          label: this.$t('campaign.budget'),
          field: 'budget',
          thClass: 'p-1 border-0 header-table-mf',
          tdClass:
            'p-1 border-top-0 border-left-0 border-right-0 border-bottom-1 align-middle',
        },
        {
          label: this.$t('campaign.createdAt'),
          field: 'createdAt',
          thClass: 'p-1 border-0 header-table-mf',
          tdClass:
            'p-1 border-top-0 border-left-0 border-right-0 border-bottom-1 align-middle',
        },
        {
          label: this.$t('campaign.actions'),
          field: 'actions',
          thClass: 'p-1 border-0 header-table-mf th-column-action',
          tdClass:
            'p-1 border-top-0 border-left-0 border-right-0 border-bottom-1 align-middle td-column-action',
        },
      ],
    }
  },

  computed: {
    ...mapGetters(['listCampaign', 'message', 'status', 'loading']),
    totalCampaign() {
      return get(this.listCampaign, ['paging', 'total'], 0)
    },

    createdDate() {
      return value => (value ? dayjs.utc(value).tz(this.advertiserId?.timezone).format('YYYY-MM-DD HH:mm') : '')
    },

    statusCampaign() {
      const statusCampaign = {
        [CAMPAIGN_STATUS.DISABLE]: this.$t('campaign.disableStatus'),
        [CAMPAIGN_STATUS.ENABLE]: this.$t('campaign.activeStatus'),
      }

      return campaign => statusCampaign[campaign && campaign.operation_status]
    },

    statusVariant() {
      const statusColor = {
        [CAMPAIGN_STATUS.DISABLE]: 'disable',
        [CAMPAIGN_STATUS.ENABLE]: 'active',
      }

      return campaign => statusColor[campaign && campaign.operation_status]
    },

    isAllChecked() {
      if (this.campaigns.length === 0) return false
      return this.campaigns.every(campaign => this.campaignSelected.includes(campaign.campaign_id))
    },

    isIndeterminate() {
      const selectedInCurrentPage = this.campaigns.filter(campaign => this.campaignSelected.includes(campaign.campaign_id)).length
      return selectedInCurrentPage > 0 && selectedInCurrentPage < this.campaigns.length
    },
  },

  watch: {
    campaignSelected: {
      handler() {
        this.$nextTick(() => {
          const cb = this.$refs.headerCb
          if (cb) cb.indeterminate = this.isIndeterminate
        })
      },
      deep: true,
    },

    campaigns() {
      this.$nextTick(() => {
        const cb = this.$refs.headerCb
        if (cb) cb.indeterminate = this.isIndeterminate
      })
    },

    listCampaign: {
      handler() {
        this.initData()
      },
      deep: true,
    },
  },

  methods: {
    ...mapActions(['getListCampaign', 'updateStatusCampaign']),
    initData() {
      this.campaigns = get(this.listCampaign, ['content'], [])
    },

    async onSortChange(params) {
      this.sortTerm.field = params[0].field
      this.sortTerm.type = params[0].type
      await this.fetchListCampaign()
    },

    async handlePerPageChange(active) {
      this.pageLength = Number(active)
      await this.$emit('fetchListCampaign', 1, active)
    },

    async handleChangePage(page) {
      await this.$emit('fetchListCampaign', page, this.pageLength)
    },

    isRowChecked(row) {
      return this.campaignSelected.includes(row.campaign_id)
    },

    isCampaignActive(row) {
      return row?.operation_status === 'ENABLE'
    },

    async onChangeCampaignStatus(row, checked) {
      const originalStatus = row.operation_status

      const params = {
        advertiserId: this.advertiserId.value,
        campaignIds: [row.campaign_id],
        operationStatus: checked ? 'ENABLE' : 'DISABLE',
      }

      await this.updateStatusCampaign(params)
      if (this.status) {
        this.campaigns = this.campaigns.map(campaign => {
          if (campaign.campaign_id === row.campaign_id) {
            return {
              ...campaign,
              operation_status: checked ? 'ENABLE' : 'DISABLE',
            }
          }
          return campaign
        })
        this.toastSuccess('Campaign status updated')
      } else {
        document.getElementById(row.campaign_id).checked = originalStatus === 'ENABLE'
        this.toastFailure(this.message)
      }
    },

    onToggleRow(row, checked) {
      if (checked) {
        if (!this.campaignSelected.includes(row.campaign_id)) {
          this.campaignSelected.push(row.campaign_id)
        }
      } else {
        const index = this.campaignSelected.indexOf(row.campaign_id)
        if (index > -1) {
          this.campaignSelected.splice(index, 1)
        }
      }
      this.$emit('handleSelectCampaigns', this.campaignSelected)
    },
    onToggleAll(checked) {
      if (checked) {
        // Thêm tất cả campaigns của trang hiện tại vào danh sách đã chọn
        this.campaigns.forEach(campaign => {
          if (!this.campaignSelected.includes(campaign.campaign_id)) {
            this.campaignSelected.push(campaign.campaign_id)
          }
        })
      } else {
        // Chỉ loại bỏ campaigns của trang hiện tại khỏi danh sách đã chọn
        const currentPageIds = this.campaigns.map(campaign => campaign.campaign_id)
        this.campaignSelected = this.campaignSelected.filter(id => !currentPageIds.includes(id))
      }

      this.$emit('handleSelectCampaigns', this.campaignSelected)
    },

    editCampaign(campaign) {
      this.$emit('editCampaign', campaign)
    },

    viewCampaign(campaign) {
      this.$emit('viewCampaign', campaign)
    },

    duplicateCampaign(campaign) {
      this.campaignDuplicate = campaign
      this.$refs['open-duplicate-campaign-modal'].showModal()
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-good-table.scss';
.input-control {
  .vs__dropdown-toggle {
    height: 40px;
  }
}

.custom-select-input {
  .vs__dropdown-toggle {
    align-items: center;
  }

  @media (max-width: 767px) {
    .vs__selected-options {
      font-size: 12px
    }

    .vs__dropdown-menu {
      font-size: 12px
    }
  }
}
</style>

<style lang="scss" scoped>
.campaign-status {
  padding: 5px 12px;
  border-radius: 100px;
  width: max-content;

  .content-status {
    margin: 0;
    text-transform: uppercase;
    font-size: 12px;
    font-weight: bold;
  }

  &.disable {
    background: rgba(0, 0, 0, 0.05);
    color: rgba(0, 0, 0, 0.5);
  }

  &.active {
    background: rgba(76, 179, 117, 0.1);
    color: #4CB375;
  }
}

.footer-tab {
  padding: 0 1rem 1rem;
}

.input-height {
  height: 40px;
}

.select-input {
  min-width: 250px;
  width: 250px;

  @media (max-width: 767px) {
    min-width: 150px;
    width: 150px;
  }
}
</style>
